import { NgModule } from '@angular/core';
import { SvgGearsComponent } from './svg-gears.component';

@NgModule({
	declarations: [],
	imports: [SvgGearsComponent],
	exports: [SvgGearsComponent],
})
export class SvgGearsModule {}
